import { serverApi } from "./serverApi";
import { Method } from "../types/sharedTypes";

export const methodService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllMethod: build.query<Array<Method>, string>({
      query: () => ({
        url: "/method/all-methods"
      })
    }),
  })
});

export const {
  useGetAllMethodQuery
} = methodService;